import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text } from '@bigcommerce/big-design';

import { taxSettingDisable } from '../../../redux/actions/taxSettings';

const DisableTaxSettingModal = ({ payload, showDisableTaxSettingModal, setShowDisableTaxSettingModal, taxSetting, disableTaxSetting }) => {
  const disable = () => {
    disableTaxSetting(payload, taxSetting.id);
    setShowDisableTaxSettingModal(false);
  }

  return(
    <>
      { taxSetting &&
        <Modal
          actions={[
            {
              text: 'Cancel',
              variant: 'subtle',
              onClick: () => setShowDisableTaxSettingModal(false),
            },
            { text: 'Disable Tax Setting', onClick: () => disable() },
          ]}
          closeOnClickOutside={true}
          closeOnEscKey={true}
          header="Disable Tax Setting"
          isOpen={showDisableTaxSettingModal}
          onClose={() => setShowDisableTaxSettingModal(false)}
        >
          <H3>Disable {taxSetting.tax_name}</H3>
          <Text>
            Confirm that this tax setting should be disabled. Suppliers using this tax setting by default will no longer have a default tax setting set.
          </Text>
        </Modal>
      }
    </>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  disableTaxSetting: (payload, taxSettingId) => dispatch(taxSettingDisable(payload, taxSettingId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DisableTaxSettingModal);